import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Modal from "@/components/Modal.vue";
// @ts-ignore
import { AuthenticationContext } from 'vue-adal';
let Tariffs = class Tariffs extends Vue {
    deleteConfirmation(item) {
        this.$data.deleteData = item;
        this.$data.modals.confirm = true;
    }
    loadLevels() {
        this.$data.loading = true;
        this.$store
            .dispatch("loadGlobalLevelsAsnyc")
            .then((result) => {
            this.$data.levels = result.data;
            this.$data.loading = false;
        })
            .catch((err) => {
            console.log("error: ", err);
        });
    }
    edit(item) {
        this.$data.selectedData = item;
        this.$data.modals.edit = true;
    }
    showCreateDialog() {
        this.$data.createData = {
            order: "",
            name: "",
            fixedPay: 0,
            payrate: 0,
            hours: 0,
            pension: 0,
            vacationDays: 0,
        };
        this.$data.modals.create = true;
    }
    update(item) {
        this.$data.loading = true;
        this.$store
            .dispatch("updateAdminLevelAsync", this.$data.selectedData)
            .then((result) => {
            this.loadLevels();
            this.$data.loading = false;
            this.$data.modals.edit = false;
        })
            .catch((err) => {
            console.log("error: ", err);
        });
    }
    createLevel() {
        this.$data.loading = true;
        this.$store
            .dispatch("createAdminLevelAsync", this.$data.createData)
            .then((result) => {
            this.loadLevels();
            this.$data.loading = false;
            this.$data.modals.create = false;
        })
            .catch((err) => {
            console.log("error: ", err);
        });
    }
    deleteLevel() {
        this.$data.loading = true;
        this.$store
            .dispatch("deleteAdminLevelAsync", this.$data.deleteData)
            .then((result) => {
            this.loadLevels();
            this.$data.loading = false;
            this.$data.modals.confirm = false;
        })
            .catch((err) => {
            console.log("error: ", err);
        });
    }
};
Tariffs = __decorate([
    Component({
        data() {
            return {
                filter: "",
                theme: this.$store.getters.getTheme,
                levelHeaders: [
                    { text: "Name", value: "name" },
                    { text: "Hours", value: "hours" },
                    { text: "Fixed", value: "fixedPay" },
                    { text: "Rate", value: "payrate" },
                    { text: "Edit", value: "edit" },
                    { text: "Delete", value: "delete" },
                ],
                levels: null,
                loading: false,
                selectedData: null,
                modals: {
                    edit: false,
                    create: false,
                    confirm: false,
                },
                createData: null,
                deleteData: null,
            };
        },
        computed: {
            isAdmin() {
                try {
                    return AuthenticationContext.checkRoles(['Admin']);
                }
                catch {
                    return false;
                }
            },
        },
        mounted() {
            this.loadLevels();
        },
        components: {
            IconBox,
            IconBoxContent,
            WhiteBox,
            Modal,
        },
    })
], Tariffs);
export default Tariffs;
